import { NgModule } from '@angular/core';
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';

import {
  faArrowLeft,
  faEllipsisV,
  faVideo,
  faPaperclip,
  faCaretRight,
  faLaugh,
  faPencilAlt,
  faKeyboard,
  faUserTie,
  faCalendarAlt,
  faSpinner,
  faEye,
  faEyeSlash,
  faSms,
  faExclamationCircle,
  faBell,
  faBars,
  faSignOutAlt,
  faBriefcase,
  faFileInvoice,
  faUser,
  faInfoCircle,
  faAngleDown,
  faAngleUp,
  faChevronLeft,
  faSuitcase,
  faCoins,
  //faEnvelopeOpenText,
  //faFileChartPie,
  faFileDownload,
  faTrash,
  faCircle,
  faChartMixed,
  faPen,
  faCircleCheck,
  faStar,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faFileInvoiceDollar,
  faTimes,
  faHouse,
  faGrid,
  faHouseUser,
  faMagnifyingGlass,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faPollH as falPollH,
  faCalendarAlt as falCalendarAlt,
  faAnalytics as falAnalytics,
  faMobile as falMobile,
  faBoxUsd as falBoxUsd,
  faSync as falSync,
  faSyncAlt as falSyncAlt,
  faSignIn as falSignIn,
  faSignOut as falSignOut,
  faSignOutAlt as falSignOutAlt,
  faFileChartLine as falFileChartLine,
  faSuitcase as falSuitcase,
  faAt as falAt,
  faUser as falUser,
  faClipboardListCheck as falClipboardListCheck,
  faCommentAlt as falCommentAlt,
  faCircleXmark as falCircleXmark,
  faCircleCheck as falCircleCheck,
  faCopy as falCopy,
  faCoins as falCoins,
  faTrash as falTrash,
  faFlagCheckered as falFlagCheckered,
  faPencilAlt as falPencilAlt,
  faPencil as falPencil,
  faCalendar as falCalendar,
  faHome as falHome,
  faArrowRight as falArrowRight,
  faTimes as falTimes,
  faEnvelopeOpen as falEnvelopeOpen,
  faEnvelopeOpenText as falEnvelopeOpenText,
  faFileAlt as falFileAlt,
  faQuestionSquare as falQuestionSquare,
  faCheckSquare as falCheckSquare,
  faExclamationSquare as falExclamationSquare,
  faQuestion as falQuestion,
  faSquarePollHorizontal as falSquarePollHorizontal,
  faClock as falClock,
  faCalendarXmark as falCalendarXmark,
  faFileXmark as falFileXmark,
  faBalanceScale as falBalanceScale,
  faBalanceScaleRight as falBalanceScaleRight,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faChartMixed as falChartMixed,
  faClose as falClose,
  faSearchDollar as falSearchDollar,
  faPen as falPen,
  faIdBadge as faIdBadge,
  faFileChartPie as faFileChartPie,
  faFileSignature as faFileSignature,
  faHistory as falHistory,
  faFileDownload as falFileDownload,
  faSignature as faSignature,
  faEnvelope as falEnvelope,
  faStar as falStar,
  faCheck as falCheck,
  faPiggyBank as falPiggyBank,
  faIslandTropical as falIslandTropical,
  faCar as falCar,
  faShieldCheck as falShieldCheck,
  faHouse as falHouse,
  faGraduationCap as falGraduationCap,
  faCouch as falCouch,
  faFirstAid as faFirstAid,
  faFileInvoice as falFileInvoice,
  faHourglassClock as falHourglassClock,
  faComments as falComments,
  faFileContract as falFileContract,
  faArrowRightArrowLeft as falArrowRightArrowLeft,
  faArrowRotateRight as falArrowRotateRight,
  faEllipsisStrokeVertical as falEllipsisStrokeVertical,
  faChartCandlestick as falChartCandlestick,
} from '@fortawesome/pro-light-svg-icons';

import {
  faCalendarAlt as fadCalendarAlt,
  faAnalytics as fadAnalytics,
  faFileDownload as fadFileDownload,
  faUserTie as fadUserTie,
  faFilePdf as fadFilePdf,
  faCoins as fadCoins,
  faIslandTropical as fadIslandTropical,
  faCar as fadCar,
  faShieldCheck as fadShieldCheck,
  faHouse as fadHouse,
  faGraduationCap as fadGraduationCap,
  faCouch as fadCouch,
  faChartLineUp as fadChartLineUp,
  faPiggyBank as fadPiggyBank,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  //faAt as farAt,
  faLightbulbOn as farLightbulbOn,
  faCoins as farCoins,
  faCheck as farCheck,
  faBan as farBan,
  faSyncAlt as farSyncAlt,
  faSlidersH as farSlidersH,
  faArrowRight as farArrowRight,
  faArrowUpRight as farArrowUpRight,
  faArrowDownRight as farArrowDownRight,
} from '@fortawesome/pro-regular-svg-icons';

// import { AngularFontAwesomeModule  } from "angular-font-awesome";
/*
import { fas, faFileDownload, faExclamationSquare } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
*/

const icons = [
  // solid
  faStar,
  faFileChartPie,
  faCoins,
  faCircle,
  faBriefcase,
  faAngleDown,
  faAngleUp,
  faInfoCircle,
  faUser,
  faFileInvoice,
  faExclamationCircle,
  faEye,
  faBars,
  faBell,
  faSms,
  faEyeSlash,
  faSpinner,
  faArrowLeft,
  faEllipsisV,
  faVideo,
  faPaperclip,
  faCaretRight,
  faLaugh,
  faPencilAlt,
  faKeyboard,
  faUserTie,
  faCalendarAlt,
  faSignOutAlt,
  faChevronLeft,
  faSuitcase,
  faChevronUp,
  //faEnvelopeOpenText,
  faFileDownload,
  faTrash,
  faChartMixed,
  faPen,
  faCircleCheck,
  faChevronDown,
  faChevronRight,
  faHouse,
  faGrid,
  faHouseUser,
  // light
  falEnvelopeOpenText,
  falClock,
  falFileInvoiceDollar,
  falBalanceScaleRight,
  falSyncAlt,
  falCalendarXmark,
  falCalendarAlt,
  falCoins,
  falFileDownload,
  falPollH,
  falCircleXmark,
  falCircleCheck,
  falAnalytics,
  falMobile,
  falBoxUsd,
  falSync,
  falSignIn,
  falSignOut,
  falSignOutAlt,
  falTrash,
  falFileChartLine,
  falAt,
  falUser,
  falSuitcase,
  falClipboardListCheck,
  falCommentAlt,
  falCopy,
  falFlagCheckered,
  falPencilAlt,
  falPencil,
  falCalendar,
  falHome,
  falArrowRight,
  falTimes,
  falEnvelopeOpen,
  falFileAlt,
  falQuestionSquare,
  falQuestion,
  falFileXmark,
  falCheckSquare,
  falExclamationSquare,
  falSquarePollHorizontal,
  falBalanceScale,
  falChartMixed,
  falClose,
  falSearchDollar,
  falPen,
  falEnvelope,
  falStar,
  falCheck,
  falPiggyBank,
  falIslandTropical,
  falCar,
  falShieldCheck,
  falHouse,
  falGraduationCap,
  falCouch,
  faFirstAid,
  falFileInvoice,
  falHourglassClock,
  falComments,
  falArrowRotateRight,
  falArrowRightArrowLeft,
  falEllipsisStrokeVertical,
  falChartCandlestick,
  falFileContract,
  // duetone
  fadCalendarAlt,
  fadAnalytics,
  fadFileDownload,
  fadUserTie,
  fadFilePdf,
  fadCoins,
  fadIslandTropical,
  fadCar,
  fadShieldCheck,
  fadHouse,
  fadGraduationCap,
  fadCouch,
  fadChartLineUp,
  fadPiggyBank,
  // regular
  //farAt,
  farLightbulbOn,
  farCoins,
  farCheck,
  farBan,
  farSyncAlt,
  farSlidersH,
  farArrowRight,
  faChartMixed,
  faIdBadge,
  faFileSignature,
  falHistory,
  faFileDownload,
  faFileInvoiceDollar,
  faTimes,
  faSignature,
  farArrowUpRight,
  farArrowDownRight,
  faMagnifyingGlass,
];

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class AwesomeModule {
  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIcons(...icons);
    //library.addIconPacks(fas, far, fab, fal, fad);
  }
}
